import styled from '@emotion/styled';

import { BREAKPOINTS, unit } from '@zego/theme';

const SectionDisplay = styled('div', {
  shouldForwardProp: prop => ['start', 'end'].indexOf(prop) === -1,
})(({ start, end }) => ({
  paddingTop: start ? unit(12) : unit(6),
  paddingBottom: end ? unit(12) : unit(6),
  [BREAKPOINTS.medium]: {
    paddingTop: start ? unit(24) : unit(12),
    paddingBottom: end ? unit(24) : unit(12),
  },
}));

export default SectionDisplay;
